import type { SVGProps } from "react";

export function FileIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			fill="currentColor"
			height="200px"
			stroke="currentColor"
			strokeWidth="0"
			viewBox="0 0 24 24"
			width="200px"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g id="File_On">
				<path d="M19.485,7.35l-4.97-4.86a1.466,1.466,0,0,0-1.05-.43h-6.9a2.5,2.5,0,0,0-2.5,2.5V19.44a2.507,2.507,0,0,0,2.5,2.5h10.87a2.507,2.507,0,0,0,2.5-2.5V8.42A1.49,1.49,0,0,0,19.485,7.35Zm-1.27.15h-2.34a1.5,1.5,0,0,1-1.5-1.5V3.75Zm.72,11.94a1.5,1.5,0,0,1-1.5,1.5H6.565a1.5,1.5,0,0,1-1.5-1.5V4.56a1.5,1.5,0,0,1,1.5-1.5h6.81V6a2.5,2.5,0,0,0,2.5,2.5h3.06Z" />
			</g>
		</svg>
	);
}
